import { Component, Input, OnInit } from '@angular/core';
import { ActivationEnd, ActivationStart, Router } from '@angular/router';
import { User } from 'src/app/shared/models/user.model';

@Component({
  selector: 'app-header-home',
  templateUrl: './header-home.component.html',
  styleUrls: ['./header-home.component.scss']
})
export class HeaderHomeComponent implements OnInit {
  @Input() module;
  bgHeader: boolean = false;
  connectedUser: User;

  constructor(private router: Router) {
    router.events.subscribe((val) => {
      if (val instanceof ActivationEnd && val.snapshot['data']) {
        this.bgHeader = true
      }
    });
  }

  ngOnInit(): void {
    if(sessionStorage.getItem('token')){
      this.connectedUser = JSON.parse(localStorage.getItem('me'))
    }
  }

  logout(){
    localStorage.removeItem('me');
    sessionStorage.removeItem('token');
    localStorage.clear();
    sessionStorage.clear();
    this.router.navigateByUrl('/authentication');
  }

}
